module.exports = __webpack_public_path__ + "static/media/hot1.2ec8a185.png";